var _slicedToArray = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var utils = require('./grid-utils');

var GridArea = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(GridArea, _Declaration);

  var _super = _createSuper(GridArea);

  function GridArea() {
    _classCallCheck(this, GridArea);

    return _super.apply(this, arguments);
  }

  _createClass(GridArea, [{
    key: "insert",
    value:
    /**
     * Translate grid-area to separate -ms- prefixed properties
     */
    function insert(decl, prefix, prefixes, result) {
      if (prefix !== '-ms-') return _get(_getPrototypeOf(GridArea.prototype), "insert", this).call(this, decl, prefix, prefixes);
      var values = utils.parse(decl);

      var _utils$translate = utils.translate(values, 0, 2),
          _utils$translate2 = _slicedToArray(_utils$translate, 2),
          rowStart = _utils$translate2[0],
          rowSpan = _utils$translate2[1];

      var _utils$translate3 = utils.translate(values, 1, 3),
          _utils$translate4 = _slicedToArray(_utils$translate3, 2),
          columnStart = _utils$translate4[0],
          columnSpan = _utils$translate4[1];

      [['grid-row', rowStart], ['grid-row-span', rowSpan], ['grid-column', columnStart], ['grid-column-span', columnSpan]].forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            prop = _ref2[0],
            value = _ref2[1];

        utils.insertDecl(decl, prop, value);
      });
      utils.warnTemplateSelectorNotFound(decl, result);
      utils.warnIfGridRowColumnExists(decl, result);
      return undefined;
    }
  }]);

  return GridArea;
}(Declaration);

GridArea.names = ['grid-area'];
module.exports = GridArea;